module.exports = __webpack_public_path__ + "static/media/25-SilvaDias(1).84578cfb.png";